import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import PerfectScrollbar from 'react-perfect-scrollbar'
import 'react-perfect-scrollbar/dist/css/styles.css'

const ModalBody = ({ className, scrollable, children }) => {
  const componentClassName = classnames('modal-body', className)
  return <div className={componentClassName}>
    {scrollable && <PerfectScrollbar>{children}</PerfectScrollbar>}
    {!scrollable && (children)}
  </div>
}

ModalBody.defaultProps = {
  scrollable: false
}

ModalBody.propTypes = {
  className: PropTypes.string,
  scrollable: PropTypes.bool,
  children: PropTypes.node
}

export default ModalBody
